// @flow

import { validateCpf } from '@tectonics/commons/cpf';

const CPF_LENGTH = 11;

export function isCpfValid(digits: string): boolean {
  return digits.length === CPF_LENGTH && validateCpf(digits);
}
